import React from 'react';

export default function useIsInIframe() {
  return React.useMemo(() => window.self !== window.top, []);
}

export function useIsFromApp() {
  return React.useMemo(() => (window.authAPI !== undefined), []);
}
